"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dataProcessing = __importStar(require("./dataProcessing"));
var SparklinesReferenceLineTypes;
(function (SparklinesReferenceLineTypes) {
    SparklinesReferenceLineTypes["max"] = "max";
    SparklinesReferenceLineTypes["min"] = "min";
    SparklinesReferenceLineTypes["mean"] = "mean";
    SparklinesReferenceLineTypes["avg"] = "avg";
    SparklinesReferenceLineTypes["median"] = "median";
    SparklinesReferenceLineTypes["custom"] = "custom";
})(SparklinesReferenceLineTypes = exports.SparklinesReferenceLineTypes || (exports.SparklinesReferenceLineTypes = {}));
var SparklinesReferenceLine = function (props) {
    var _a = props.points, points = _a === void 0 ? [] : _a, _b = props.margin, margin = _b === void 0 ? 0 : _b, _c = props.type, type = _c === void 0 ? SparklinesReferenceLineTypes.mean : _c, _d = props.style, style = _d === void 0 ? { stroke: "red", strokeOpacity: 0.75, strokeDasharray: "2, 2" } : _d, value = props.value;
    var ypoints = points.map(function (p) { return p.y; });
    var y = type == "custom"
        ? value
        : dataProcessing[type](ypoints);
    return (react_1.default.createElement("line", { x1: points[0].x, y1: (y ? y : 0) + margin, x2: points[points.length - 1].x, y2: (y ? y : 0) + margin, style: style }));
};
exports.default = SparklinesReferenceLine;
//# sourceMappingURL=SparklinesReferenceLine.js.map